var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrialStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.999 12a.998.998 0 0 1-.523-.148L16 4.174 3.524 11.852a1 1 0 1 1-1.048-1.704l13-8a.997.997 0 0 1 1.048 0l13 8A1 1 0 0 1 29 12z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 30H5a1 1 0 0 1-1-1V13a1 1 0 0 1 2 0v15h20V13a1 1 0 1 1 2 0v16a1 1 0 0 1-1 1z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.525 15.15c-.02-.013-6.077-3.045-6.077-3.045a1.001 1.001 0 0 0-.895 0s-6.057 3.03-6.079 3.044A1 1 0 0 0 9 16v7a1 1 0 0 0 .553.895l6 3a1 1 0 0 0 .894 0l6-3A1 1 0 0 0 23 23v-7a1 1 0 0 0-.475-.85zM16 14.117 19.764 16 16 17.882 12.236 16zm-5 3.5 4 2v4.764l-4-2zm10 4.764-4 2v-4.764l4-2z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrialStock);
export default __webpack_public_path__ + "static/media/matrial-stock.8dbfb99ce327c3a2a6ccb0d3f10f4577.svg";
export { ForwardRef as ReactComponent };